// Assets
import CallToActionIcon from "../../imgs/double-arrow.svg";
import DropDownIcon from "../../imgs/Icon-pack.svg";

// Header Row
export const RowOne = [
    {
        title: "Total savings balance",
        amount: "₦194,000",
        cta: "View details",
        ctaIcon: CallToActionIcon
    },
    {
        title: "Total customers",
        amount: "₦919",
        cta: "View details",
        ctaIcon: CallToActionIcon
    },
    {
        title: "Total POS",
        amount: "0",
        cta: "View details",
        ctaIcon: CallToActionIcon
    }
]
// Row Two
export const RowTwo = [
    {
        title: "Total transfer",
        cta: "More",
        ctaIcon: DropDownIcon,
        MidDate1: "Today",
        MidAmount1: "₦500",
        MidDate2: "Yesterday",
        MidAmount2: "₦200",
        EndDate1: "This Week",
        EndAmount1: "₦500",
        EndDate2: "Last Week",
        EndAmount2: "₦200",
    },
    {
        title: "Total inflow",
        cta: "More",
        ctaIcon: DropDownIcon,
        MidDate1: "Today",
        MidAmount1: "₦2,000,000",
        MidDate2: "Yesterday",
        MidAmount2: "₦5,000,000",
        EndDate1: "This Week",
        EndAmount1: "₦5,000,000",
        EndDate2: "Last Week",
        EndAmount2: "₦5,000,000",
    },
    {
        title: "Total transactions",
        cta: "More",
        ctaIcon: DropDownIcon,
        MidDate1: "Today",
        MidAmount1: "₦2,000,000",
        MidDate2: "Yesterday",
        MidAmount2: "₦5,000,000",
        EndDate1: "This Week",
        EndAmount1: "₦5,000,000",
        EndDate2: "Last Week",
        EndAmount2: "₦5,000,000",
    },
    {
        title: "Total count",
        cta: "More",
        ctaIcon: DropDownIcon,
        MidDate1: "Today",
        MidAmount1: "₦2,000,000",
        MidDate2: "Yesterday",
        MidAmount2: "₦5,000,000",
        EndDate1: "This Week",
        EndAmount1: "₦5,000,000",
        EndDate2: "Last Week",
        EndAmount2: "₦5,000,000",
    }
]

// Row Three
export const RowThree = [
    {
        title: "Total Cashout",
        dateDropDown: "Today",
        ctaIcon: DropDownIcon,
        title2: "Today",
        amount: "₦1,200,000",
        title3: "Yesterday",
        amount2: "₦1,200,000",
    },
    {
        title: "Transaction status",
        dateDropDown: "Today",
        ctaIcon: DropDownIcon,
        title2: "Successful",
        amount: "422",
        title3: "Failed",
        amount2: "18",
    },
    {
        title: "Average transaction Count",
        dateDropDown: "Today",
        ctaIcon: DropDownIcon,
        title2: "Value",
        amount: "₦20,400",
        title3: "Count",
        amount2: "422",
    },
    {
        title: "Total commission",
        dateDropDown: "Today",
        ctaIcon: DropDownIcon,
        title2: "POS commission",
        amount: "₦87,000",
        title3: "Lotto commisson",
        amount2: "₦102,000",
    }
]